export enum ProgramFilter {
  None,
  NotificationsOnly,
  AccessAndNotifications
}
